interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(current: number, totalPages: number): number[] {
  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - current) <= 1) {
      pages.push(i);
    }
  }
  return pages;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(current, totalPages);

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
        className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300/70 px-3 py-2 text-sm text-foreground-600 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line text-lg" aria-hidden="true"></i>
        上一页
      </button>

      {pages.map((page, index) => {
        const prev = pages[index - 1];
        const showEllipsis = prev && page - prev > 1;
        return (
          <span key={page} className="flex items-center gap-2">
            {showEllipsis && <span className="px-1 text-foreground-500">···</span>}
            <button
              type="button"
              onClick={() => onChange(page)}
              className={`h-9 w-9 cursor-pointer rounded-md text-sm transition-colors ${
                page === current
                  ? "bg-accent-500 font-semibold text-background-50"
                  : "border border-background-300/70 text-foreground-600 hover:bg-background-100"
              }`}
            >
              {page}
            </button>
          </span>
        );
      })}

      <button
        type="button"
        disabled={current >= totalPages}
        onClick={() => onChange(current + 1)}
        className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300/70 px-3 py-2 text-sm text-foreground-600 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line text-lg" aria-hidden="true"></i>
      </button>
    </nav>
  );
}